export default "__VITE_ASSET__S0MDyRR4__"